import React from "react";

import { LineTableContainer, LineTableHeaderRow, LineTableRow } from "./style";

type Props<TItem> = {
  items: TItem[];
  headers: React.ReactNode[];
  getRowValues: (item: TItem) => React.ReactNode[];
  emptyCell?: React.ReactNode;
  ariaLive?: "off" | "polite" | "assertive";
};

const LineTable = <TItem,>({
  items,
  headers,
  getRowValues,
  emptyCell = "—",
  ariaLive,
}: Props<TItem>): React.ReactElement => {
  const noItems = items.length === 0;

  return (
    <LineTableContainer aria-live={ariaLive}>
      <LineTableHeaderRow>
        {headers.map((header, index) => (
          <div key={index}>{header}</div>
        ))}
      </LineTableHeaderRow>

      {noItems ? (
        <LineTableRow>
          {headers.map((_, index) => (
            <div key={index}>{emptyCell}</div>
          ))}
        </LineTableRow>
      ) : (
        items.map((item, index) => (
          <LineTableRow key={index}>
            {getRowValues(item).map((value, columnIndex) => (
              <div key={columnIndex}>{value}</div>
            ))}
          </LineTableRow>
        ))
      )}
    </LineTableContainer>
  );
};

export default LineTable;
